






















































































































import { Component } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import { ManagementReportsModule } from '@/store/modules/managementReports';
import { formatPercent, formatNumber } from '@/lib/reportFormatters';

@Component({ name: 'OpportunityReports' })
export default class OpportunityReports extends GiganautVue {

  get companyLabel(): string { return this.Labels.company || 'Company'; }

  get overviewHeaders() {
    return [
      { text: 'Opportunity', value: 'name' },
      { text: 'Stage', value: 'stageLabel' },
      { text: this.companyLabel, value: 'companyName' },
      { text: 'Owner', value: 'ownerName' },
    ];
  }

  get dormancyHeaders() {
    return [
      { text: 'Opportunity', value: 'name' },
      { text: 'Stage', value: 'stageLabel' },
      { text: this.companyLabel, value: 'companyName' },
      { text: 'Owner', value: 'ownerName' },
      { text: 'Days Since Activity', value: 'daysSinceActivity', align: 'end' },
      { text: 'Status', value: 'status' },
    ];
  }

  get opportunityOverview() { return ManagementReportsModule.opportunityOverview; }
  get opportunityDormancy() { return ManagementReportsModule.opportunityDormancy; }

  stageColor(stage: number): string {
    // Mirrors OPPORTUNITY_STAGE_* constants in api/core/opportunities.go.
    switch (stage) {
      case 10: return 'blue-grey';     // New
      case 20: return 'cyan darken-1'; // Qualified
      case 30: return 'indigo';        // Proposing
      case 40: return 'deep-purple';   // Negotiating
      case 90: return 'green';         // Won
      case 95: return 'red';           // Lost
      default: return 'grey';
    }
  }

  dormancyColor(status: string): string {
    switch (status) {
      case 'active': return 'green';
      case 'cooling': return 'amber darken-2';
      case 'dormant': return 'orange';
      case 'stale': return 'red';
      default: return 'grey';
    }
  }

  goToOpportunity(id: string) {
    this.$router.push('/agency/opportunities/' + id);
  }

  fmtPct(v: number) { return formatPercent(v); }
  fmtNum(v: number) { return formatNumber(v); }
}
